import React from 'react';
import { Select } from 'antd';
import { SelectContainer } from 'shared/styles';
import { VrUser, VrUserInternal } from 'shared/types';

type UserWithEmail = VrUser | VrUserInternal | { id: string; email: string; firstName?: string; lastName?: string };

type MultipleProps = {
    multiple: true;
    value: string[];
    handleUserChange: (userIds: string[]) => void;
};

type SingleProps = {
    multiple?: false;
    value?: string;
    handleUserChange: (userId: string) => void;
};

type Props = {
    users: UserWithEmail[];
    disabled?: boolean;
    fullWidth?: boolean;
} & (MultipleProps | SingleProps);

const formatUserLabel = (user: UserWithEmail): string => {
    const name = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();
    return name ? `${name} — ${user.email}` : user.email;
};

const UserSelectByEmail: React.FC<Props> = ({
    users,
    disabled,
    value,
    handleUserChange,
    multiple,
    fullWidth,
}) => {
    const sortedUsers = [...users].sort((a, b) =>
        a.email.localeCompare(b.email, undefined, { sensitivity: 'base' })
    );

    const filterOption = (input: string, option?: any) => {
        if (!option?.searchText) return false;
        return option.searchText.toLowerCase().includes(input.toLowerCase());
    };

    const select = (
        <Select
            style={{ width: '100%' }}
            popupMatchSelectWidth={false}
            mode={multiple ? 'multiple' : undefined}
            value={value && (Array.isArray(value) ? value.length > 0 : true) ? value : undefined}
            onChange={handleUserChange as any}
            placeholder="All users by email or name (default)"
            disabled={disabled}
            allowClear
            showSearch
            filterOption={filterOption}
            options={sortedUsers.map(user => ({
            value: user.id,
            label: formatUserLabel(user),
            searchText: `${user.email} ${user.firstName ?? ''} ${user.lastName ?? ''}`,
            }))}
        />
    );

    if (fullWidth) {
        return <div style={{ width: '100%' }}>{select}</div>;
    }

    return <SelectContainer>{select}</SelectContainer>;
};

export default UserSelectByEmail;
